// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__1bTg9","header":"ClearentDisclaimer_header__Y2HUf","inner":"ClearentDisclaimer_inner__AzdBX"};